import { images } from 'src/onboarding/constants/images';

export const mealMappings = {
  breakfast: {
    "Greek yogurt with chia seeds, berries, and granola": {
      label: 'onboarding.chooseBreakfast.options.yogurt',
      image: images.breakfast9,
    },
    "Omelette with tomatoes and basil": {
      label: 'onboarding.chooseBreakfast.options.omelette',
      image: images.breakfast6,
    },
    "Oat pancakes with banana": {
      label: 'onboarding.chooseBreakfast.options.pancakes',
      image: images.breakfast4,
    },
    "Toast with avocado and shrimp/salmon": {
      label: 'onboarding.chooseBreakfast.options.toast',
      image: images.breakfast7,
    },
    "Scrambled eggs with beans in tomato sauce": {
      label: 'onboarding.chooseBreakfast.options.eggs',
      image: images.breakfast10,
    },
    "Sandwich with peanut butter and banana, served with Greek yogurt and berries": {
      label: 'onboarding.chooseBreakfast.options.sandwich',
      image: images.breakfast12,
    }
  },
  lunch: {
    "Grilled chicken breast with bulgur and zucchini": {
      label: 'onboarding.chooseLunch.options.chicken',
      image: images.lunch43,
    },
    "Beef quesadilla": {
      label: 'onboarding.chooseLunch.options.beef',
      image: images.lunch45,
    },
    "Pasta with tuna and tomatoes": {
      label: 'onboarding.chooseLunch.options.pasta',
      image: images.lunch50,
    },
    "Stuffed eggplants": {
      label: 'onboarding.chooseLunch.options.eggplants',
      image: images.lunch51,
    },
    "Rice with shrimp": {
      label: 'onboarding.chooseLunch.options.rice',
      image: images.lunch54,
    },
    "Cutlet with cheddar cheese and bulgur": {
      label: 'onboarding.chooseLunch.options.cutlet',
      image: images.lunch57,
    }
  },
  dinner: {
    "Turkey steak with vegetables": {
      label: 'onboarding.chooseDinner.options.steak',
      image: images.dinner64,
    },
    "Asian-style squid rice": {
      label: 'onboarding.chooseDinner.options.rice',
      image: images.dinner73,
    },
    "Pasta with chicken and vegetables": {
      label: 'onboarding.chooseDinner.options.pasta',
      image: images.dinner76,
    },
    "Cod cutlets with a side of fresh vegetables": {
      label: 'onboarding.chooseDinner.options.cutlets',
      image: images.dinner80,
    },
    "Sea bass with potatoes": {
      label: 'onboarding.chooseDinner.options.seabass',
      image: images.dinner83,
    },
    "Chili con carne": {
      label: 'onboarding.chooseDinner.options.chili',
      image: images.dinner81,
    }
  },
  snack: {
    "Granola with milk": {
      label: 'onboarding.chooseSnack.options.granola',
      image: images.snack24,
    },
    "Whole-grain crispbreads with soft cheese and salmon": {
      label: 'onboarding.chooseSnack.options.crispbreads',
      image: images.snack25,
    },
    "Pink smoothie": {
      label: 'onboarding.chooseSnack.options.smoothie',
      image: images.snack27,
    },
    "Avocado and chickpea sandwich": {
      label: 'onboarding.chooseSnack.options.sandwich',
      image: images.snack37,
    },
    "Tuna and bean salad": {
      label: 'onboarding.chooseSnack.options.salad',
      image: images.snack36,
    },
    "Raspberry-chocolate pudding": {
      label: 'onboarding.chooseSnack.options.pudding',
      image: images.snack35,
    }
  }
};